var _rect, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 23.4,
    height: 23.4,
    rx: 5.7,
    stroke: "#A3A3A3",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62424 12.1758C7.38993 11.9414 7.01003 11.9414 6.77571 12.1758C6.5414 12.4101 6.5414 12.79 6.77571 13.0243L9.77571 16.0243C10.01 16.2586 10.3899 16.2586 10.6242 16.0243L17.2242 9.42429C17.4586 9.18997 17.4586 8.81007 17.2242 8.57576C16.9899 8.34145 16.61 8.34145 16.3757 8.57576L10.2 14.7515L7.62424 12.1758Z",
    fill: "#656565"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_240_3002",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 12,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62424 12.1758C7.38993 11.9414 7.01003 11.9414 6.77571 12.1758C6.5414 12.4101 6.5414 12.79 6.77571 13.0243L9.77571 16.0243C10.01 16.2586 10.3899 16.2586 10.6242 16.0243L17.2242 9.42429C17.4586 9.18997 17.4586 8.81007 17.2242 8.57576C16.9899 8.34145 16.61 8.34145 16.3757 8.57576L10.2 14.7515L7.62424 12.1758Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_240_3002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/check_box.d89f7977345cb12106bafff2d2fb0e97.svg";
export { ForwardRef as ReactComponent };